export default __webpack_public_path__ + "static/133-603ebf21ced8781c09c0015851a46f15.gif";